export const en = {
    'avg-click-cost': 'Average CPC',
    'avg-click-cost-with-currency': 'Average CPC, {currency}',
    'avg-cpm-cost': 'Average CPM',
    'avg-cpm-cost-with-currency': 'Average CPM, {currency}',
    'avg-goal-cost': 'Average CPA',
    'avg-goal-cost-with-currency': 'Average CPA, {currency}',
    avgClickCost: 'CPC',
    avgGoalCost: 'CPA',
    'bounce-rate-with-percent': 'Bounce rate, %',
    bounceRate: 'Bounce rate',
    clicks: 'Clicks',
    conversionRate: 'Conversions, %',
    cost: 'Expenditure',
    'cost-with-currency': 'Expenditure, {currency}',
    ctr: 'CTR',
    'ctr-with-percent': 'CTR, %',
    goals: 'Conversions',
    profitability: 'ROI',
    'profitability-words': 'Average ROI',
    revenue: 'Revenue',
    'revenue-with-currency': 'Revenue, {currency}',
    shows: 'Impressions'
};
